import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserNotification } from '@shared';

/**
 * No-op NotificationsService for the user (customer) app (in-app notification list / bell).
 * Web push still uses FCMService + POST /notifications/register-token — not this service.
 */
@Injectable()
export class NotificationsDisabledService {
  getNotifications(_filter?: unknown, _pageSize?: number): Observable<UserNotification[]> {
    return of([]);
  }

  getUnreadCount(_filter?: unknown): Observable<number> {
    return of(0);
  }

  loadMoreNotifications(
    _lastNotification: UserNotification,
    _filter?: unknown,
    _pageSize?: number
  ): Observable<UserNotification[]> {
    return of([]);
  }
}
